// Resolved before tenant-dependent providers mount. Never trust a persisted
// browser value as domain ownership; each page load asks the public registry.
let mapping = null;
export const getCustomDomainMapping = () => mapping;
export const needsDomainResolution = () => {
  const host = window.location.hostname.toLowerCase();
  return !(['localhost', '127.0.0.1', 'plateos.io', 'www.plateos.io', 'getyofo.com', 'www.getyofo.com'].includes(host)
    || host.endsWith('.plateos.io') || host.endsWith('.emergent.host') || host.endsWith('.emergentagent.com'));
};
export async function resolveCustomDomain() {
  mapping = null;
  if (!needsDomainResolution()) return null;
  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/domains/map/${encodeURIComponent(window.location.hostname)}`, { credentials: 'omit' });
  const data = await response.json();
  if (!response.ok || !data.success || !data.subdomain) throw new Error('This domain is not connected to a store yet.');
  mapping = data;
  return data;
}

export function customDomainEntryPath(pathname) {
  if (!mapping) return null;
  const base = mapping.store_slug ? `/customers/${encodeURIComponent(mapping.store_slug)}` : '/customers';
  if (pathname === '/') return base;
  if (pathname === '/login') return `${base}/login`;
  if (pathname === '/reset-password') return `${base}/reset-password`;
  if (mapping.store_slug && (pathname === '/customers' || pathname.startsWith('/customers/'))) {
    const parts = pathname.split('/').filter(Boolean);
    if (parts[1] === mapping.store_slug) return null;
    const pages = ['login', 'reset-password', 'plans', 'checkout', 'dashboard', 'about', 'contact', 'menu', 'meal-passes', 'theme'];
    const tail = pages.includes(parts[1]) ? parts.slice(1) : parts.slice(2);
    return base + (tail.length ? '/' + tail.join('/') : '');
  }
  return null;
}
